import "./polyfill";
import "./localisation";

import Vue from "vue";
import { Component } from "vue-property-decorator";
import VueRouter from "vue-router";
import * as Logger from "js-logger";
import VeeValidate from "vee-validate";

import Config from "./config.json";

import * as Store from "./store";
import { store } from "./store";

import router from "./router";

import Navbar from "./components/navbar";
import Foot from "./components/foot";

import template from "./main.vue";
import "./plugins/bootstrap";
import "./plugins/font-awesome";
import Vue2Filters from "vue2-filters";

Vue.use(Vue2Filters);
Vue.use(VeeValidate);

Vue.filter("toCurrency", function(value: number) {
  let formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter("size", function(num: number) {
  return (num / 1024).toFixed(1) >= "1"
    ? (num / 1024).toFixed(1) + " GB"
    : num + " MB";
});

let logLevel = Config.debug ? Logger.DEBUG : Logger.ERROR;
Logger.useDefaults();
Logger.setLevel(logLevel);

Vue.config.errorHandler = function(err, vm, info) {
  Logger.error("Vue error: ", err);
};

@Component({
  mixins: [template],
  store,
  components: {
    Navbar,
    Foot
  },
  router
})
class App extends Vue {
  mounted() {
    Logger.log("mounted");

    const loaderVisible = Store.readLoaderVisibility(this.$store);
    Logger.info("loader is visible: ", loaderVisible);
  }
}

window.onerror = function(errorMsg, url, lineNo, colNo, error) {
  Logger.error("Global event: ", errorMsg);

  Store.commitLoaderVisibility(store, false);
};

export const app = new App().$mount("#app");



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/main.ts